/**
 * Admin Layout component with admin-specific navigation
 */

import React, { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface AdminLayoutProps {
  children: ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const adminNavItems = [
    {
      name: 'Dashboard',
      path: '/admin',
      icon: '📊'
    },
    {
      name: 'Users',
      path: '/admin/users',
      icon: '👥'
    },
    {
      name: 'Labs',
      path: '/admin/labs',
      icon: '🧪'
    },
    {
      name: 'Lab Grading Details',
      path: '/admin/lab-grading',
      icon: '✅'
    },
    {
      name: 'Monitoring',
      path: '/admin/monitoring',
      icon: '📈'
    },
    {
      name: 'Settings',
      path: '/admin/settings',
      icon: '⚙️'
    },
    {
      name: 'Feedback',
      path: '/admin/feedback',
      icon: '📨'
    }
  ];

  return (
    <div className="bg-gray-900 min-h-screen">
      {/* Admin Sub-Navigation */}
      <div className="bg-gray-800 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-8 overflow-x-auto">
            {adminNavItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-2 py-4 px-1 border-b-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive(item.path)
                    ? 'border-blue-500 text-white'
                    : 'border-transparent text-gray-300 hover:border-gray-300 hover:text-white'
                }`}
              >
                <span className="text-base">{item.icon}</span>
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div>
        {children}
      </div>
    </div>
  );
}
